/**
 * Sales CRM Services
 *
 * Centralized export of all Sales CRM services for easy importing
 */
export * from './contacts.service';
export * from './deals.service';
export * from './activities.service';
export * from './follow-ups.service';
export * from './settings.service';
export * from './email.service';
export * from './onboarding.service';
import { salesContactsService } from './contacts.service';
import { salesDealsService } from './deals.service';
import { salesActivitiesService } from './activities.service';
import { salesFollowUpsService } from './follow-ups.service';
import { salesSettingsService } from './settings.service';
import { salesEmailService } from './email.service';
import { salesOnboardingService } from './onboarding.service';
/**
 * Unified Sales CRM Service
 * Provides access to all sales-related services
 */
export const salesService = {
    contacts: salesContactsService,
    deals: salesDealsService,
    activities: salesActivitiesService,
    followUps: salesFollowUpsService,
    settings: salesSettingsService,
    email: salesEmailService,
    onboarding: salesOnboardingService
};
// Default export
export default salesService;
